<ng-template #addstandarduser>
  <div id="acceptDiv" *ngIf="showCreate">
    <div class="modal-header">
      <h4 class="modal-title pull-left">{{header}} User</h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="onClose()">
        <span aria-hidden="true">X</span>
      </button>
    </div>
    <div class="modal-body add-standard-user">
      <form [formGroup]="addUserForm" autocomplete="off">
        <div class="form-group">

          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <div *ngIf="!IsEditMode" class="profilepic">
                  <img #profilePic src="{{userInputModel.ProfilePicPath}}">
                  <file-upload (selectedFilesListEmitter)=selectedFilesListEmitter($event) (selectedFilePathEmitter)="selectedFilePathEmitter($event)" [uploadType]="fileUploadType" [clearFilescounter]="clearFiles"></file-upload>
                  <a *ngIf="imageIdToDelete != null" href="javascript:void(0);" (click)="openModalForDelete(template,'deletemodal',imageIdToDelete,'the profile picture')" class="deletepic" triggers="hover" tooltip="Remove">
                    <i class="icofont icofont-close icon"></i>
                  </a>
                </div>
                <div *ngIf="IsEditMode" class="profilepic">
                  <img #profilePic src="{{userInputModel.ProfilePicPath}}">
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">
                  First Name
                  <span class="star">*</span>
                </label>
                <div>
                  <input type="text" formControlName="txtFirstName" [disabled]="(IsEditMode)" [(ngModel)]="userInputModel.FirstName" placeholder="First Name" autocomplete="off" maxlength="30" dropSpecialCharacters="false" class="form-control" required>
                  <div *ngIf="(txtFirstName.invalid && isSubmitted)|| (txtFirstName.invalid && (txtFirstName.dirty || txtFirstName.touched))">
                    <p class="redtext" *ngIf="txtFirstName.errors.required">
                      First Name is required
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">
                  Last Name
                  <span class="star">*</span>
                </label>
                <div>
                  <input type="text" formControlName="txtLastName" [disabled]="(IsEditMode)" [(ngModel)]="userInputModel.LastName" placeholder="Last Name" autocomplete="off" maxlength="30" dropSpecialCharacters="false" class="form-control" required>
                  <div *ngIf="(txtLastName.invalid && isSubmitted)|| (txtLastName.invalid && (txtLastName.dirty || txtLastName.touched))">
                    <p class="redtext" *ngIf="txtLastName.errors.required">
                      Last Name is required
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">
                  Email
                  <span class="star">*</span>
                </label>
                <div>
                  <input type="text" [disabled]="(IsEditMode)" (change)="validateemail()" autocomplete="off" maxlength="100" formControlName="txtEmail" [(ngModel)]="userInputModel.EmailAddress" class="form-control" placeholder="Email" required>
                  <div *ngIf="(txtEmail.invalid && isSubmitted )||(txtEmail.invalid && (txtEmail.dirty || txtEmail.touched))">
                    <p class="redtext" *ngIf="txtEmail.errors.EmailCheck">
                      Invalid Email Address
                    </p>
                    <p class="redtext" *ngIf="txtEmail.errors.required">
                      Email Address is required
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">
                  Property
                  <span class="star">*</span>
                </label>
                <div class="select-dropdown  multiselectdesign multiselect-check-all select-check">
                  <mat-form-field>
                    <mat-select [(ngModel)]="propertyIds"
                                [ngModelOptions]="{standalone: true}"
                                formControlName="lstRole"
                                placeholder="Select Property"
                                multiple (click)="addClassToOverlayContainer();">
                      @if (propertyIds?.length > 1) {
                        <mat-select-trigger>
                          <span>{{ propertyIds?.length }} items checked</span>
                        </mat-select-trigger>
                      }    
                        <!-- Search Option -->
                        <mat-option>
                          <ngx-mat-select-search
                              #searchKey
                              [disableInitialFocus]="true"
                              [hideClearSearchButton]="true"
                              placeholderLabel="Search here"
                              noEntriesFoundLabel="Nothing found..."
                              [enableClearOnEscapePressed]="true"
                          ></ngx-mat-select-search>
                        </mat-option>
                      <!-- Select/Unselect All Options -->
                      <mat-option class="select-all-option hide-checkbox">
                        <div class="d-flex justify-content-between">
                          <span class="select-all-text" (click)="$event.stopPropagation(); selectAllProperty()">
                            <i class="fa fa-check"></i> Select All
                          </span>
                          <span class="select-all-text" (click)="$event.stopPropagation(); unselectAllProperty()">
                            <i class="fa fa-times"></i> Unselect All
                          </span>
                        </div>
                      </mat-option>
                      <!-- Property Options -->
                      @for (property of propertyList | arraySearch : 'name' : searchKey.value; track property) {
                        <mat-option [value]="property.id" class="multi-dropdown-item">{{property.name}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <div *ngIf="(lstRole.invalid && isSubmitted )||(lstRole.invalid && (lstRole.dirty || lstRole.touched))">
                    <p class="redtext" *ngIf="lstRole.errors.required">
                      {{ addPropertyValidation }}
                    </p>
                  </div>
                  <!-- <span class="redtext" *ngIf="lstRole.errors?.required">{{addPropertyValidation}}</span> -->
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">
                  Phone
                  <span class="star">*</span>
                </label>
                <div>
                  <input class="form-control" formControlName="txtPhone" required [(ngModel)]="userInputModel.PhoneNumber" mask='(000) 000-0000' type="text" placeholder="Phone" maxlength="20">
                  <div *ngIf="(txtPhone.invalid && isSubmitted )||(txtPhone.invalid && (txtPhone.dirty || txtPhone.touched))">
                    <p class="redtext" *ngIf="txtPhone.errors.minlength">
                      Invalid Phone no.
                    </p>
                    <p class="redtext" *ngIf="txtPhone.errors.required">
                      Phone number is required
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!--<div class="form-group">
              <textarea class="form-control textarea-min-height" maxlength="4000"  required type="text" placeholder="Please enter comments"></textarea>
              <p class="redtext">Please enter comments </p>
          </div>-->
          <div class="text-right">
            <button class="btn btn-default btn-lg" id="closeModal" (click)="cancel()">Cancel</button>
            <button type="button" (click)="saveUser()" class="btn btn-success btn-lg">{{header}}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>
<div class="row margin-top-20">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <!--<ul class="switchingproperty" style="margin:-20px 0 10px 0">
      <li [class.active]="currentTab == tabs.StandardUsers" (click)="onTabClick(tabs.StandardUsers)">
        <a href="javascript:void(0);">
          Users
        </a>
      </li>
    </ul>-->
    <div class="container min-heightcontainer" *ngIf="currentTab == tabs.StandardUsers">
      <ng-container>
        <div class="row">
          <div class="floatinghead clearfix">
          </div>
        </div>
        <div class="clearfix"></div>
        <ng-container>
          <div class="margin-bottom-40">
            <div class="d-flex margin-bottom-15 table-actions-hdr flex-wrap cf width100">
              <div class="col-lg-4">
                <h3 class="bluelabel margin-bottom-0 margin-top-10">Access Controls</h3>
              </div>
              <div class="col-lg-8">
                <div class="d-flex right-actions">
                  <div class="ml-auto d-flex m-w-100">
                    <div class="search-sec m-w-100 margin-right-20">
                      <input class="form-control" [(ngModel)]="searchText" type="text" maxlength="30" (keyup)='search($event.target.value)' placeholder="Search">
                      <i class="fa fa-search icon" aria-hidden="true"></i>
                    </div>
                  </div>
                  <div class="leftside clearfix">
                    <div class="d-flex flex-direction-colum flex-1">
                      <button class="right-btn btn btn-addgreen btn-lg margin-bottom-10" (click)="create(addstandarduser, 'addstandardusermodal');">+ ADD USER</button>
                    </div>
                  </div>
                </div>
                
              </div>
              
            </div>
            <div class="cf list-table">
              <div class="table-responsive">
                <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
                  <thead>
                    <tr>
                      <th data-orderable="false">
                        Actions
                      </th>
                      <th>
                        Name
                      </th>
                      <th>
                        Associated Properties
                      </th>
                      <th>
                        Recent Activity
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let preference of filterData; let i=index">
                      <td style="width:10%" class="whitespacenowrap">
                        <a href="javascript:void(0);" (click)="openDeleteModal(RemovePreference, '', preference.Id);" class="blueone" tooltip="Remove" placement="top">
                          <i class="icofont icofont-close" aria-hidden="true"></i>
                        </a>
                        <a href="javascript:void(0);"  routerLink="/standarduser-detail" [queryParams]="{'PrincipalUserGuid':UserGuid, 'user':preference.UserGuid}" class="blueone" tooltip="Edit" placement="top">
                          <i class="icofont icofont-ui-edit" aria-hidden="true"></i>
                        </a>
                      </td>
                      <td *ngIf="preference.UserStatus != 'Invited'">
                        <p class="d-flex">
                          <a href="javascript:void(0);" routerLink="/standarduser-detail" [queryParams]="{'PrincipalUserGuid':UserGuid, 'user':preference.UserGuid}">  {{preference.FirstName}} {{preference.LastName}}</a>
                        </p>
                        {{preference.Phone ? (preference.Phone|phone) : '-'}}<br />
                        {{preference.Email}}
                      </td>
                      <td *ngIf="preference.UserStatus == 'Invited'">
                        {{preference.Email}}
                        <br />
                        <p style="color: #02C29F">Invite Pending</p>
                      </td>
                      <td>
                        {{preference.AssociatedPropertyCount}} Properties
                        <p class="d-flex">
                          <a (click)="openEditModal(EditPreference, '', preference.Id);;"> - View/Manage Property Access</a>
                        </p>
                      </td>
                      <td>{{preference.RecentActivity| date:'MM/dd/yyyy'}}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr *ngIf="filterData?.length == 0 &&!IsLoading">
                      <td colspan="8" class="odd no-data-available">
                        <div class="nodata">
                          <i class="fa fa-exclamation-triangle icon"></i>
                          <p>No Data Available</p>
                        </div>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>

            <ng-template #RemovePreference>

              <div class="modal-header">
                <h4 class="modal-title pull-left">Remove Access</h4>
                <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefDelete.hide()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <h4 style="color: #003D5D; font-weight: bold">Are you sure you want to remove {{deleteUser.FirstName}} {{deleteUser.LastName}}’s access from all properties?</h4>
                <div class="margin-bottom-15">
                  <div style="padding-left:20px;">
                    <a *ngIf="deleteUser.UserStatus!='Invited'" (click)="deleteroute()" style="color:#337ab7" href="javascript:void(0);">  {{deleteUser.FirstName}} {{deleteUser.LastName}}</a>
                    <p>{{deleteUser.Email}}</p>
                    <p style="color: #02C29F" *ngIf="deleteUser.UserStatus=='Invited'">Invite Pending</p>

                  </div>
                  <hr>
                </div>
                <div class="text-right">
                  <button class="btn btn-lg btn-default" style="color: #003D5D;font-weight:bold" (click)="modalRefDelete.hide();openEditModal(EditPreference, '', deleteId);"> &lt; No, Edit Property Access</button>
                  <button class="btn btn-lg btn-addgreen" (click)="delete();">YES, REMOVE ACCESS</button>
                </div>
              </div>

            </ng-template>
            <ng-template #EditPreference>

              <div class="modal-header">
                <h4 class="modal-title pull-left">Edit Access</h4>
                <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefEdit.hide()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body modal-scroll-body">
                <h4 style="color: #003D5D; font-weight: 600;font-size:24px;" class="margin-bottom-15">Edit Access to your Portfolio</h4>
                <div class="margin-bottom-15">
                  <div style="padding-left:26px;">
                    <a *ngIf="editUser.UserStatus!='Invited'" (click)="editroute()" style="color:#337ab7" href="javascript:void(0);">  {{editUser.FirstName}} {{editUser.LastName}}</a>
                    <p>{{editUser.Email}}</p>
                    <p style="color: #02C29F" *ngIf="editUser.UserStatus=='Invited'">Invite Pending</p>
                    <label class="custom-checkbox withoutlabel margin-top-30">
                      <input type="checkbox" [(ngModel)]="selectAll" (change)="onSelectAll($event);" class="ng-pristine ng-valid ng-touched"><i></i> <span class="requestBovTenant"><b>Entire Portfolio</b></span>
                    </label>
                  </div>
                  <hr>
                </div>
                <div class="row" *ngIf="properties!=null && properties?.length>0">
                  <ul *ngFor="let myList of properties;let j = index " class="property-list">
                    <li class="transition">
                      <label class="custom-checkbox withoutlabel">
                        <input type="checkbox" [(ngModel)]="myList.IsChecked" (change)="onCheckboxChange($event.target.checked,myList.Guid);" class="ng-pristine ng-valid ng-touched"><i></i> <span class="requestBovTenant"><b>{{myList.DisplayName}}</b>{{myList.Address}}</span>
                      </label>
                    </li>
                  </ul>
                </div>
                <div class="text-right">
                  <button class="btn btn-lg btn-addgreen" (click)="EditAccess(RemoveAccess,'');">EDIT ACCESS</button>
                </div>
              </div>

            </ng-template>
            <ng-template #RemoveAccess>

              <div class="modal-header">
                <h4 class="modal-title pull-left">Edit Access</h4>
                <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefRemoveAccess.hide()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <h4 style="color: #003D5D; font-weight: bold">Are you sure you want to remove {{editUser.FirstName}} {{editUser.LastName}}’s access to these properties?</h4>
                <div class="margin-bottom-15">
                  <div style="padding-left:20px;">
                    <a *ngIf="editUser.UserStatus!='Invited'" (click)="removeAccessroute()" style="color:#337ab7" href="javascript:void(0);">  {{editUser.FirstName}} {{editUser.LastName}}</a>
                    <p>{{editUser.Email}}</p>
                    <p style="color: #02C29F" *ngIf="editUser.UserStatus=='Invited'">Invite Pending</p>

                  </div>
                  <hr>
                </div>
                <div class="row" *ngIf="propertiesToRemove!=null && properties?.length>0">
                  <ul *ngFor="let myList of propertiesToRemove;let j = index ">
                    <li class="transition">
                      <span class="requestBovTenant"><b>{{myList.DisplayName}}</b>{{myList.Address}}</span>
                    </li>
                  </ul>
                </div>
                <div class="text-right">
                  <button class="btn btn-lg btn-addgreen" (click)="RemoveProperty();">YES, REMOVE</button>
                </div>
              </div>

            </ng-template>
            <ng-template #GrantAccess>

              <div class="modal-header">
                <h4 class="modal-title pull-left">Add User</h4>
                <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefGrantAccess.hide()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <h4 style="color: #003D5D; font-weight:bold">Grant Access to your Portfolio</h4>
                <div class="margin-bottom-15">
                  <div>
                    <p>This email is already registered in the system.{{principalName!=''?(' Did you mean '):''}}<b>{{principalName!=''?(principalName):''}}</b> ?</p>
                  </div>
                </div>
                <div class="margin-bottom-15">
                  <div>
                    <p>{{userInputModel.EmailAddress}}</p>
                  </div>
                </div>
                <div class="text-right">
                  <button class="btn btn-lg btn-addgreen" (click)="changeStatus(2);saveUser();">GRANT ACCESS</button>
                </div>
              </div>

            </ng-template>
          </div>
        </ng-container>
      </ng-container>
      <div class="clearfix"></div>
    </div>
  </div>
</div>

